import * as L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import { useTranslation } from "react-i18next";
const buttonSvg = window.btoa('<svg class="svg-icon" style="width: 1em;height: 1em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M952 474H829.8C812.5 327.6 696.4 211.5 550 194.2V72c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v122.2C327.6 211.5 211.5 327.6 194.2 474H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h122.2C211.5 696.4 327.6 812.5 474 829.8V952c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V829.8C696.4 812.5 812.5 696.4 829.8 550H952c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM512 756c-134.8 0-244-109.2-244-244s109.2-244 244-244 244 109.2 244 244-109.2 244-244 244z" fill="#595959" /><path d="M512 392c-32.1 0-62.1 12.4-84.8 35.2-22.7 22.7-35.2 52.7-35.2 84.8s12.5 62.1 35.2 84.8C449.9 619.4 480 632 512 632s62.1-12.5 84.8-35.2C619.4 574.1 632 544 632 512s-12.5-62.1-35.2-84.8C574.1 404.4 544.1 392 512 392z" fill="#595959" /></svg>');
export const RecenterButton = ({ onClick }) => {
    const { t } = useTranslation();
    const map = useMap();
    useEffect(() => {
        const customControl = new L.Control({ position: "bottomright" });
        customControl.onAdd = function () {
            const container = L.DomUtil.create("div", "leaflet-bar leaflet-control custom-button-control");
            const button = L.DomUtil.create("a", "", container);
            button.innerHTML =
                '<img src="' +
                    encodeURI("data:image/svg+xml;base64," + buttonSvg).replace("#", "%23") +
                    '" />';
            button.href = "#";
            button.title = t("recenterButton.title");
            L.DomEvent.on(button, "click", (e) => {
                L.DomEvent.stopPropagation(e);
                L.DomEvent.preventDefault(e);
                onClick();
            });
            return container;
        };
        customControl.addTo(map);
        return () => {
            customControl.remove();
        };
    }, [map]);
    return null;
};
